import { isPending } from "App/apiMiddleware";
import get from "lodash/get";
import values from "lodash/values";
import { createSelector } from "reselect";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const getWorkSpaces = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].workSpaces`), (data) => (data ? values(data) : undefined));
export const getInProgress = (state) => isPending(state, actionTypes.GET_WORK_SPACES);
